export default {
  INSERT: Symbol('INSERT'),
  MOVE: Symbol('MOVE'),
  COPY: Symbol('COPY'),
  TRANSCLUDE: Symbol('TRANSCLUDE')
}



// WEBPACK FOOTER //
// ./src/paste-action.js